import { DISCOVERY_DECADES } from "@garimpa/lib/discoveryDecades";

/** Decade shortcuts shaped for the generic search filter contract. */
export const SEARCH_DECADES = DISCOVERY_DECADES.map((decade) => ({
  label: decade.label,
  from: decade.startYear,
  to: decade.endYear,
  count: null as number | null,
}));
